module.exports = __webpack_public_path__ + "static/fullstack-serverless-b64307d18dacbef815c980e40cdb6de2.png";